import React from 'react';
import DataGrid from '@dataGrid';
import PickupHistoryGridConfig from './GridConfig';
import { compose } from 'recompose';
import styles from '../PickupInfoGrid/styles';
import { withStyles } from '@material-ui/core';
import Events from '../../../../../../../../../utilities/EventEmitter';

class PickupHistoryGrid extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      quickFilterText: ''
    };
    this.gridConfig = new PickupHistoryGridConfig();
  }

  componentDidMount() {
    Events.on('pickupHistoryGrid', this.onSearchTextChanged);
  }
  componentWillUnmount() {
    Events.off('pickupHistoryGrid', this.onSearchTextChanged);
  }
  onSearchTextChanged = (searchText) => {
    this.setState({
      quickFilterText: searchText
    });
  };
  onGridReady = ({ api }) => {
    Events.emit(`setGridApi`, { api, gridName: this.gridConfig.config.title });
  };

  render() {
    const { classes, gridInfo } = this.props;
    return (
      <div className={classes.dataGrid}>
        <DataGrid
          defaultColDef={this.gridConfig.config.defaultColDef}
          columnDefs={this.gridConfig.config.columns}
          columnTypes={this.gridConfig.config.columnTypes}
          config={this.gridConfig.config}
          rowSelection={this.gridConfig.config.rowSelection}
          rowDeselection={this.gridConfig.config.rowDeselection}
          rowData={gridInfo?.data ?? []}
          onGridReady={this.onGridReady}
          layoutContainer={this.props.glContainer}
          panelLabel={this.constructStatusBar}
          showErrorMessage={gridInfo.gridStatus}
          quickFilterText={this.state.quickFilterText}
        />
      </div>
    );
  }
}
export default compose(withStyles(styles))(PickupHistoryGrid);
